import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';


const SubAccountListPage = lazy(() => import('src/pages/management/managementBandwidth/subaccounts/list'));

export const managementBandwidthRoutes = [
  {
    path: 'management-bandwidth',
    // permissions: ["menu_managementPBX"],
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [{ path: 'sub-accounts/list', element: <SubAccountListPage /> /* permissions: ["pbx_user"] */ }],
  },
];
